import React, {useState} from "react";
import styles, {C} from "../styles";
import Modal from "./Modal";
import {apiChangePassword} from "../api/auth";

export default function ForcedPasswordChangeModal({onSuccess}) {
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [message, setMessage] = useState("");

    async function handleSubmit() {
        setMessage("");
        const data = await apiChangePassword(oldPassword, newPassword);
        if (data.error) { setMessage(data.error); return; }
        onSuccess();
    }

    return (
        <Modal title="Changement de mot de passe requis" onClose={() => {}}>
            <p style={{fontSize: 13, color: C.textMuted}}>
                Votre compte a été créé par un administrateur. Pour continuer, choisissez un
                nouveau mot de passe.
            </p>
            <input type="password" placeholder="Mot de passe actuel (fourni par l'administrateur)" value={oldPassword}
                   onChange={e => setOldPassword(e.target.value)} style={styles.input}/>
            <input type="password" placeholder="Nouveau mot de passe" value={newPassword}
                   onChange={e => setNewPassword(e.target.value)} style={styles.input}/>
            <button onClick={handleSubmit} style={styles.primaryButton}>Valider</button>
            {message && <p style={{marginTop: 8, fontSize: 13, color: C.danger}}>{message}</p>}
        </Modal>
    );
}
